module.exports = __webpack_public_path__ + "static/hero-bg-536269f2ccdd0df8d1d70a983bc13bb3.png";